import React from 'react';
import './css/styles_smartclassroom.min.css';
import PropTypes from 'prop-types';

class NetexCloudMenu extends React.Component {
  static propTypes = {
    colored: PropTypes.bool,
    options: PropTypes.array
  };

  state = {
    dropdownActive: false,
    dropdownButtonActive: false
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClose);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  clickDropdown(e) {
    this.setState({ dropdownActive: true });
  }

  clickDropdownButton(e) {
    this.setState({ dropdownButtonActive: !this.state.dropdownButtonActive });
  }

  loadDropdownMenuCss() {
    if (this.state.dropdownButtonActive) {
      return 'dropdown__menu grid grid4 active';
    }
    return 'dropdown__menu grid grid4';
  }

  handleClose = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        dropdownActive: false,
        dropdownButtonActive: false
      });
    }
  };

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  render() {
    return (
      <div ref={this.setWrapperRef}>
        <div className="dropdown" onClick={e => this.clickDropdown(e)}>
          <button className="dropdown__btn" type="button" onClick={e => this.clickDropdownButton(e)}>
            <span className="icon-netex icon-dashboard icon-24" style={this.getSpanStyle()}></span>
          </button>
          {this.props.options && (
            <div className={this.loadDropdownMenuCss()}>
              {this.props.options.map(app => {
                return (
                  <a key={app.url} href={app.url} className="app-container">
                    <img src={app.image.url} alt={app.image.label} />
                    <span>{app.image.label}</span>
                  </a>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }

  getSpanStyle() {
    if (this.props.colored) {
      return { color: 'darkgray' };
    }
    return {};
  }
}

export default NetexCloudMenu;
